import { __rest, __assign } from 'tslib';
import React, { useContext, forwardRef, useRef } from 'react';
import mergeRefs from 'react-merge-refs';
import cn from 'classnames';
import { Comment } from '@alfalab/core-components-comment/esm';
import { useFocus } from '@alfalab/hooks';
import { getDataTestId } from '@alfalab/core-components-shared/esm';
import { Amount as Amount$1 } from '@alfalab/core-components-amount/esm';
import { Typography } from '@alfalab/core-components-typography/esm';
import { Button } from '@alfalab/core-components-button/esm';

var styles$a = {"component":"pure-cell__component_1769n","none":"pure-cell__none_1769n","default":"pure-cell__default_1769n","addonPadding":"pure-cell__addonPadding_1769n","auto":"pure-cell__auto_1769n","top":"pure-cell__top_1769n","center":"pure-cell__center_1769n","bottom":"pure-cell__bottom_1769n"};
require('./components/addon/index.css')

var Addon = function (_a) {
    var children = _a.children, _b = _a.verticalAlign, verticalAlign = _b === void 0 ? 'top' : _b, _c = _a.addonPadding, addonPadding = _c === void 0 ? 'default' : _c, dataTestId = _a.dataTestId;
    var pureCellContext = useContext(PureCellContext);
    return (React.createElement("section", { className: cn(styles$a.component, styles$a[addonPadding], styles$a[verticalAlign]), "data-test-id": getDataTestId(dataTestId || pureCellContext.dataTestId, 'addon') }, children));
};

var styles$9 = {"component":"pure-cell__component_1loxt"};
require('./components/amount/index.css')

var Amount = function (_a) {
    var _b = _a.weight, weight = _b === void 0 ? 'normal' : _b, _c = _a.textView, textView = _c === void 0 ? 'component' : _c, _d = _a.color, color = _d === void 0 ? 'primary' : _d, minority = _a.minority, _e = _a.minorUnits, minorUnits = _e === void 0 ? 100 : _e, dataTestId = _a.dataTestId, restProps = __rest(_a, ["weight", "textView", "color", "minority", "minorUnits", "dataTestId"]);
    var pureCellContext = useContext(PureCellContext);
    return (React.createElement(Typography.Text, { view: textView, dataTestId: getDataTestId(dataTestId || pureCellContext.dataTestId, 'amount-text'), className: cn(styles$9.component), color: color },
        React.createElement(Amount$1, __assign({ minority: minority || minorUnits, bold: weight === 'bold' ? 'full' : 'none', dataTestId: getDataTestId(dataTestId || pureCellContext.dataTestId, 'amount') }, restProps))));
};

var styles$8 = {"component":"pure-cell__component_rcgyg","weight":"pure-cell__weight_rcgyg"};
require('./components/amount-title/index.css')

var AmountTitle = function (_a) {
    var minority = _a.minority, _b = _a.minorUnits, minorUnits = _b === void 0 ? 100 : _b, className = _a.className, _c = _a.color, color = _c === void 0 ? 'primary' : _c, dataTestId = _a.dataTestId, _d = _a.titleProps, titleProps = _d === void 0 ? {} : _d, restProps = __rest(_a, ["minority", "minorUnits", "className", "color", "dataTestId", "titleProps"]);
    var pureCellContext = useContext(PureCellContext);
    var titleDefaultProps = __assign({ tag: 'h4', view: 'small', color: color }, titleProps);
    return (React.createElement(Typography.Title, __assign({}, titleDefaultProps, { dataTestId: getDataTestId(dataTestId || pureCellContext.dataTestId, 'amount-title'), className: cn(styles$8.component, titleProps.className) }),
        React.createElement(Amount$1, __assign({ minority: minority || minorUnits, className: cn(styles$8.weight, className), dataTestId: getDataTestId(dataTestId || pureCellContext.dataTestId, 'core-amount-title') }, restProps, { bold: 'none' }))));
};

var styles$7 = {"component":"pure-cell__component_skrok","categoryName":"pure-cell__categoryName_skrok","categoryPercent":"pure-cell__categoryPercent_skrok","rightAddon":"pure-cell__rightAddon_skrok"};
require('./components/category/index.css')

var Category = function (_a) {
    var categoryName = _a.categoryName, categoryPercent = _a.categoryPercent, rightAddons = _a.rightAddons, dataTestId = _a.dataTestId;
    var pureCellContext = useContext(PureCellContext);
    return (React.createElement("div", { className: styles$7.component, "data-test-id": 'cell-pure-category' },
        React.createElement(Typography.Text, { view: 'primary-small', color: 'secondary', dataTestId: getDataTestId(dataTestId || pureCellContext.dataTestId, 'category-name'), className: styles$7.categoryName }, categoryName),
        categoryPercent !== undefined && (React.createElement(Typography.Text, { tag: 'div', view: 'primary-small', color: 'secondary', className: styles$7.categoryPercent, dataTestId: getDataTestId(dataTestId || pureCellContext.dataTestId, 'category-percent') },
            categoryPercent,
            "%")),
        rightAddons !== undefined && (React.createElement("div", { className: styles$7.rightAddon, "data-test-id": getDataTestId(dataTestId || pureCellContext.dataTestId, 'category-right-addon') }, rightAddons))));
};

var styles$6 = {"component":"pure-cell__component_usovd","horizontal":"pure-cell__horizontal_usovd"};
require('./components/content/index.css')

var Content = function (_a) {
    var _b;
    var children = _a.children, dataTestId = _a.dataTestId;
    var _c = useContext(PureCellContext), direction = _c.direction, contextDataTestId = _c.dataTestId;
    return (React.createElement("section", { className: cn(styles$6.component, (_b = {}, _b[styles$6.horizontal] = direction === 'horizontal', _b)), "data-test-id": getDataTestId(dataTestId || contextDataTestId, 'content') }, children));
};

var styles$5 = {"component":"pure-cell__component_17wih","none":"pure-cell__none_17wih","default":"pure-cell__default_17wih"};
require('./components/footer/index.css')

var Footer = function (_a) {
    var children = _a.children, _b = _a.footerPadding, footerPadding = _b === void 0 ? 'default' : _b, dataTestId = _a.dataTestId;
    var pureCellContext = useContext(PureCellContext);
    return (React.createElement("footer", { className: cn(styles$5.component, styles$5[footerPadding]), "data-test-id": getDataTestId(dataTestId || pureCellContext.dataTestId, 'footer') }, children));
};

var styles$4 = {"component":"pure-cell__component_6ojmm"};
require('./components/footer-button/index.css')

var FooterButton = forwardRef(function (_a, ref) {
    var children = _a.children, dataTestId = _a.dataTestId, props = __rest(_a, ["children", "dataTestId"]);
    var pureCellContext = useContext(PureCellContext);
    return (React.createElement(Button, __assign({}, props, { size: 'xxs', dataTestId: getDataTestId(dataTestId || pureCellContext.dataTestId, 'button'), className: styles$4.component, ref: ref }), children));
});

var FooterText = function (_a) {
    var children = _a.children, _b = _a.color, color = _b === void 0 ? 'secondary' : _b, dataTestId = _a.dataTestId;
    var pureCellContext = useContext(PureCellContext);
    return (React.createElement(Typography.Text, { view: 'primary-small', color: color, "data-test-id": getDataTestId(dataTestId || pureCellContext.dataTestId, 'footer-title') }, children));
};

var styles$3 = {"component":"pure-cell__component_xhf99","top":"pure-cell__top_xhf99","center":"pure-cell__center_xhf99","bottom":"pure-cell__bottom_xhf99","horizontal":"pure-cell__horizontal_xhf99","none":"pure-cell__none_xhf99","airy":"pure-cell__airy_xhf99","default":"pure-cell__default_xhf99","compact":"pure-cell__compact_xhf99","tiny":"pure-cell__tiny_xhf99","vertical":"pure-cell__vertical_xhf99"};
require('./components/graphics/index.css')

var Graphics = function (_a) {
    var children = _a.children, dataTestId = _a.dataTestId, _b = _a.verticalAlign, verticalAlign = _b === void 0 ? 'top' : _b, graphicPadding = _a.graphicPadding;
    var pureCellContext = useContext(PureCellContext);
    var defaultGraphicPadding = pureCellContext.direction === 'horizontal' ? 'airy' : 'default';
    return (React.createElement("section", { className: cn(styles$3.component, styles$3[verticalAlign], styles$3[pureCellContext.direction || 'horizontal'], styles$3[graphicPadding || defaultGraphicPadding]), "data-test-id": getDataTestId(dataTestId || pureCellContext.dataTestId, 'graphics') }, children));
};

var styles$2 = {"component":"pure-cell__component_19tfu","vertical":"pure-cell__vertical_19tfu","reverse":"pure-cell__reverse_19tfu"};
require('./components/main/index.css')

var Main = function (_a) {
    var _b;
    var children = _a.children, isReverse = _a.isReverse, className = _a.className, dataTestId = _a.dataTestId;
    var _c = useContext(PureCellContext), _d = _c.direction, direction = _d === void 0 ? 'horizontal' : _d, contextDataTestId = _c.dataTestId;
    return (React.createElement("div", { className: cn(styles$2.component, styles$2[direction], (_b = {},
            _b[styles$2.reverse] = isReverse,
            _b), className), "data-test-id": getDataTestId(dataTestId || contextDataTestId, 'main') }, children));
};

var styles$1 = {"horizontal":"pure-cell__horizontal_1ima4","rowLimit1":"pure-cell__rowLimit1_1ima4","rowLimit2":"pure-cell__rowLimit2_1ima4","component":"pure-cell__component_1ima4","vertical":"pure-cell__vertical_1ima4","title":"pure-cell__title_1ima4","value":"pure-cell__value_1ima4"};
require('./components/text/index.css')

var Text = function (_a) {
    var _b;
    var children = _a.children, value = _a.value, rowLimit = _a.rowLimit, _c = _a.view, view = _c === void 0 ? 'component-primary' : _c, titleWeight = _a.titleWeight, titleColor = _a.titleColor, valueColor = _a.valueColor, dataTestId = _a.dataTestId;
    var _d = useContext(PureCellContext), _e = _d.direction, direction = _e === void 0 ? 'horizontal' : _e, contextDataTestId = _d.dataTestId;
    var className = rowLimit && styles$1["rowLimit".concat(rowLimit)];
    return (React.createElement("div", { className: cn(styles$1.component, (_b = {},
            _b[styles$1.vertical] = direction !== 'horizontal',
            _b)) },
        React.createElement("div", { className: styles$1.title },
            React.createElement(Typography.Text, { view: view, weight: titleWeight, tag: 'div', color: titleColor, className: className, "data-test-id": getDataTestId(dataTestId || contextDataTestId, 'text_content') }, children)),
        value && (React.createElement("div", { className: styles$1.value },
            React.createElement(Typography.Text, { view: view, tag: 'div', color: valueColor, className: className, "data-test-id": getDataTestId(dataTestId || contextDataTestId, 'text_value') }, value)))));
};

var styles = {"component":"pure-cell__component_1vn59","horizontal":"pure-cell__horizontal_1vn59","vertical":"pure-cell__vertical_1vn59","button":"pure-cell__button_1vn59","link":"pure-cell__link_1vn59","none":"pure-cell__none_1vn59","airy":"pure-cell__airy_1vn59","default":"pure-cell__default_1vn59","compact":"pure-cell__compact_1vn59","tiny":"pure-cell__tiny_1vn59","noneTop":"pure-cell__noneTop_1vn59","airyTop":"pure-cell__airyTop_1vn59","defaultTop":"pure-cell__defaultTop_1vn59","compactTop":"pure-cell__compactTop_1vn59","tinyTop":"pure-cell__tinyTop_1vn59","noneBottom":"pure-cell__noneBottom_1vn59","airyBottom":"pure-cell__airyBottom_1vn59","defaultBottom":"pure-cell__defaultBottom_1vn59","compactBottom":"pure-cell__compactBottom_1vn59","tinyBottom":"pure-cell__tinyBottom_1vn59","left":"pure-cell__left_1vn59","right":"pure-cell__right_1vn59","both":"pure-cell__both_1vn59","focused":"pure-cell__focused_1vn59"};
require('./index.css')

// eslint-disable-next-line @typescript-eslint/no-redeclare
var PureCellContext = React.createContext({});
var PureCellComponent = forwardRef(function (_a, ref) {
    var _b, _c;
    var className = _a.className, dataTestId = _a.dataTestId, onClick = _a.onClick, href = _a.href, _d = _a.tag, Component = _d === void 0 ? (href && 'a') || (onClick && 'button') || 'section' : _d, children = _a.children, _e = _a.horizontalPadding, horizontalPadding = _e === void 0 ? 'none' : _e, _f = _a.verticalPadding, verticalPadding = _f === void 0 ? 'none' : _f, _g = _a.direction, direction = _g === void 0 ? 'horizontal' : _g, restProps = __rest(_a, ["className", "dataTestId", "onClick", "href", "tag", "children", "horizontalPadding", "verticalPadding", "direction"]);
    var cellRef = useRef(null);
    var focused = useFocus(cellRef, 'keyboard')[0];
    var addClasses = (_b = {},
        _b[styles.component] = true,
        _b[styles.focused] = focused,
        _b[styles[direction]] = true,
        _b[styles[horizontalPadding]] = true,
        _b);
    if (typeof verticalPadding === 'string') {
        addClasses[styles[verticalPadding]] = typeof verticalPadding === 'string';
    }
    if (typeof verticalPadding === 'object') {
        addClasses[styles["".concat(verticalPadding.top, "Top")]] = !!verticalPadding.top;
        addClasses[styles["".concat(verticalPadding.bottom, "Bottom")]] = !!verticalPadding.bottom;
    }
    if (href) {
        var target = restProps.target;
        // Для совместимости с react-router-dom, меняем href на to
        var hrefProps = (_c = {}, _c[typeof Component === 'string' ? 'href' : 'to'] = href, _c);
        return (React.createElement(Component, __assign({ rel: target === '_blank' ? 'noreferrer noopener' : undefined }, restProps, hrefProps, { ref: mergeRefs([cellRef, ref]), className: cn(styles.link, addClasses, className), "data-test-id": dataTestId, onClick: onClick }),
            React.createElement(PureCellContext.Provider, { value: { direction: direction, dataTestId: dataTestId } }, children)));
    }
    if (onClick) {
        return (React.createElement(Component, __assign({}, restProps, { ref: mergeRefs([cellRef, ref]), className: cn(styles.button, addClasses, className), "data-test-id": dataTestId, onClick: onClick }),
            React.createElement(PureCellContext.Provider, { value: { direction: direction, dataTestId: dataTestId } }, children)));
    }
    return (React.createElement(Component, __assign({}, restProps, { ref: ref, tabIndex: 0, className: cn(addClasses, className), "data-test-id": dataTestId }),
        React.createElement(PureCellContext.Provider, { value: { direction: direction, dataTestId: dataTestId } }, children)));
});
/**
 * Универсальный конструктор для сборки любой ячейки.
 *
 * [Макет](https://www.figma.com/file/KlFOLLkKO8rtvvQE3RXuhq/Click-Library?node-id=43525%3A240018)
 */
var PureCell = Object.assign(PureCellComponent, {
    Main: Main,
    Graphics: Graphics,
    Content: Content,
    Text: Text,
    Amount: Amount,
    AmountTitle: AmountTitle,
    Addon: Addon,
    Footer: Footer,
    ExtraSubtitle: FooterText,
    FooterButton: FooterButton,
    Comment: Comment,
    Category: Category,
});

export { Addon as A, Category as C, Footer as F, Graphics as G, Main as M, PureCell as P, Text as T, Amount as a, AmountTitle as b, Content as c, FooterButton as d, FooterText as e, PureCellContext as f };
